import { SettingsAccountPage } from '@/views/settings/SettingsAccountPage';
import { SettingsManagersPage } from '@/views/settings/SettingsManagersPage';
import { SettingsRolesPage } from '@/views/settings/SettingsRolesPage';
import { SettingsAppointmentTypesPage } from '@/views/settings/SettingsAppointmentTypesPage';
import { SettingsAppointmentRemindersPage } from '@/views/settings/SettingsAppointmentRemindersPage';
import { SettingsEmailTemplateBuilderPage } from '@/views/settings/SettingsEmailTemplateBuilderPage';
import { SettingsEmailTemplateBuilderEditPage } from '@/views/settings/SettingsEmailTemplateBuilderEditPage';
import { SettingsCalendarViewPage } from '@/views/settings/SettingsCalendarViewPage';
import { SettingsGenericUrlsPage } from '@/views/settings/SettingsGenericUrlsPage';
import { SettingsRoleAddPage } from '@/views/settings/SettingsRoleAddPage';
import { SettingsCustomisePage } from '@/views/settings/SettingsCustomisePage';
import { SettingsKpiRecipientsPage } from '@/views/settings/SettingsKpiRecipientsPage';
import { RIGHT_CREATE, RIGHT_LIST, RIGHT_READ, CONSULT } from '@/helpers/rights';
function getSettingsChildrenRoutes(isMatmut = false, isUrlBuilderAvailable = false, isVyvEsAccount = false) {
    const settingsChildrenRoutes = [
        {
            path: '/settings/account',
            name: SettingsAccountPage.name,
            component: SettingsAccountPage,
            meta: {
                showAppHeader: true,
                icon: 'case',
                text: 'SETTINGS.MENU.ACCOUNT',
                showAppHeaderProgress: true,
                rightBlock: 'account_rights',
                right: RIGHT_READ,
                pageType: CONSULT,
                cleanPath: '/settings/account',
            },
        },
        {
            path: '/settings/managers/:page([0-9]+)?',
            name: SettingsManagersPage.name,
            component: SettingsManagersPage,
            meta: {
                showAppHeader: true,
                icon: 'persons',
                text: 'SETTINGS.MENU.MANAGERS',
                showAppHeaderProgress: true,
                rightBlock: 'manager_rights',
                right: RIGHT_LIST,
                pageType: CONSULT,
                cleanPath: '/settings/managers',
            },
        },
        {
            path: '/settings/roles/:page([0-9]+)?',
            name: SettingsRolesPage.name,
            component: SettingsRolesPage,
            meta: {
                showAppHeaderProgress: true,
                showAppHeader: true,
                icon: 'icon_paper',
                text: 'SETTINGS.MENU.ROLES',
                rightBlock: 'right_rights',
                right: RIGHT_LIST,
                pageType: CONSULT,
                cleanPath: '/settings/roles',
            },
        },
        {
            path: '/settings/roles/add',
            name: 'SettingsRoleAddPage',
            component: SettingsRoleAddPage,
            meta: {
                showAppHeader: true,
                showAppHeaderProgress: true,
                rightBlock: 'right_rights',
                right: RIGHT_CREATE,
                pageType: CONSULT,
            },
        },
        {
            path: '/settings/roles/:id',
            name: `SettingsRoleAddPageEdit`,
            component: SettingsRoleAddPage,
            meta: {
                showAppHeader: true,
                showAppHeaderProgress: true,
                rightBlock: 'right_rights',
                right: RIGHT_READ,
            },
        },
        {
            path: '/settings/appointment-types/:page([0-9]+)?',
            name: 'SettingsAppointmentTypesPage',
            component: SettingsAppointmentTypesPage,
            meta: {
                showAppHeader: true,
                icon: 'icon_suite',
                text: 'SETTINGS.MENU.APPT.TYPES',
                showAppHeaderProgress: true,
                rightBlock: 'appointment_category_rights',
                right: RIGHT_LIST,
                pageType: CONSULT,
                cleanPath: '/settings/appointment-types',
            },
        },
        ...(isVyvEsAccount ?
            [
                {
                    path: '/settings/email-template-builder/:page([0-9]+)?',
                    name: 'SettingsEmailTemplateBuilderPage',
                    component: SettingsEmailTemplateBuilderPage,
                    meta: {
                        showAppHeader: true,
                        showAppHeaderProgress: true,
                        icon: 'email_letter',
                        text: 'SETTINGS.MENU.APPT.EMAILS',
                        rightBlock: 'email_template_rights',
                        right: RIGHT_LIST,
                        pageType: CONSULT,
                        cleanPath: '/settings/email-template-builder',
                    },
                },
                {
                    path: '/settings/email-template-builder/:id/edit',
                    name: 'SettingsEmailTemplateBuilderEditPage',
                    component: SettingsEmailTemplateBuilderEditPage,
                    meta: {
                        showAppHeader: true,
                        showAppHeaderProgress: true,
                        hide: true,
                        icon: 'email_letter',
                        text: 'SETTINGS.MENU.APPT.EMAILS',
                        rightBlock: 'email_template_rights',
                        right: RIGHT_READ,
                        pageType: CONSULT,
                        cleanPath: '/settings/email-template-builder',
                    },
                },
            ] : []),
        {
            path: '/settings/appointment-reminders',
            name: SettingsAppointmentRemindersPage.name,
            component: SettingsAppointmentRemindersPage,
            meta: {
                showAppHeader: true,
                showAppHeaderProgress: true,
                icon: 'alarm',
                text: 'SETTINGS.MENU.APPT.REMINDERS',
                rightBlock: 'appointment_notification_rights',
                right: RIGHT_LIST,
                pageType: CONSULT,
                cleanPath: '/settings/appointment-reminders',
            },
        },
        {
            path: '/settings/calendar-view',
            name: SettingsCalendarViewPage.name,
            component: SettingsCalendarViewPage,
            meta: {
                showAppHeader: true,
                showAppHeaderProgress: true,
                icon: 'icon_calendar_empty',
                text: 'SETTINGS.MENU.CALENDAR.VIEW',
                rightBlock: 'calendar_view_setting_rights',
                right: RIGHT_READ,
                pageType: CONSULT,
                cleanPath: '/settings/calendar-view',
            },
        },
        {
            path: '/settings/kpi-recipients',
            name: SettingsKpiRecipientsPage.name,
            component: SettingsKpiRecipientsPage,
            meta: {
                showAppHeader: true,
                showAppHeaderProgress: true,
                icon: 'at-dialog',
                text: 'SETTINGS.ROLE.RIGHTS.KPI.RECIPIENTS',
                rightBlock: 'kpis_recipient_rights',
                right: RIGHT_LIST,
                pageType: CONSULT,
                cleanPath: '/settings/kpi-recipients',
            },
        },
    ];
    if (isUrlBuilderAvailable) {
        settingsChildrenRoutes.push({
            path: '/settings/generic-urls',
            name: SettingsGenericUrlsPage.name,
            component: SettingsGenericUrlsPage,
            meta: {
                showAppHeader: true,
                showAppHeaderProgress: true,
                icon: 'url',
                text: 'SETTINGS.ROLE.RIGHTS.GENERIC.URLS',
                rightBlock: 'calendar_view_setting_rights',
                right: RIGHT_READ,
                pageType: CONSULT,
            },
        });
    }
    if (isMatmut && process.env.VUE_APP_DEPLOY_TYPE === `staging`) {
        settingsChildrenRoutes.push({
            path: '/settings/customise',
            name: SettingsCustomisePage.name,
            component: SettingsCustomisePage,
            meta: {
                showAppHeader: true,
                showAppHeaderProgress: true,
                icon: 'settings-lines',
                text: 'SETTINGS.MENU.CUSTOMISATION',
                rightBlock: 'calendar_view_setting_rights',
                right: RIGHT_READ,
                pageType: CONSULT,
                cleanPath: '/settings/customise',
            },
        });
    }
    return settingsChildrenRoutes;
}
export default getSettingsChildrenRoutes;
